import { startTransition } from "react";
import { axiosV2 } from "config/@axios";
import i18next from "i18next";

import * as messageActions from "pages/Mail/Messages/store/messageActions";
import * as folderActions from "pages/Folders/store/folderActions";
import * as uiActions from "store/actions/uiActions";
import { getFolderAbsPath } from "pages/Folders/helpers/denormalizeFolder";
import { buildSyncedFolderUrl } from "pages/Folders/helpers/syncUrlAfterRename";

export const OPEN_FOLDER_ADD = "foldersActions::openFolderAdd";
export const CLOSE_FOLDER_ADD = "foldersActions::closeFolderAdd";

export const OPEN_FOLDER_PROPERTIES = "foldersActions::openFolderProperties";
export const CLOSE_FOLDER_PROPERTIES = "foldersActions::closeFolderProperties";
export const OPEN_FOLDER_SHARE = "foldersActions::openFolderShare";
export const CLOSE_FOLDER_SHARE = "foldersActions::closeFolderShare";
export const ADD_LIFE_TIME = "foldersActions::addFolderItemsLifeTime";
export const ADD_LIFE_TIME_ERROR = "foldersActions::folderLifeTimeError";
export const LIFETIME_VALUE_ERROR = "foldersActions::lifeTimeValueError";

export const FOLDER_LIFETIME_FAIL = "foldersActions::folderLifetimeFail";

export const OPEN_FOLDER_RENAME = "foldersActions::openFolderRename";
export const CLOSE_FOLDER_RENAME = "foldersActions::closeFolderRename";
export const OPEN_FOLDER_MOVE = "foldersActions::openFolderMove";
export const CLOSE_FOLDER_MOVE = "foldersActions::closeFolderMove";
export const OPEN_FOLDER_CLEAR = "foldersActions::openFolderClear";
export const CLOSE_FOLDER_CLEAR = "foldersActions::closeFolderClear";
export const OPEN_FOLDER_MARK_ALL_READ = "foldersActions::openMarkAllRead";
export const CLOSE_FOLDER_MARK_ALL_READ =
  "foldersActions::closeFolderMarkAllRead";
export const OPEN_FOLDER_DELETE = "foldersActions::openFolderDelete";
export const CLOSE_FOLDER_DELETE = "foldersActions::closeFolderDelete";
export const ADD_FOLDER = "foldersActions::addFolder";
export const ADD_FOLDER_SUCCESS = "foldersActions::addFolderSuccess";
export const ADD_FOLDER_FAILED = "foldersActions::addFolderFailed";
export const RENAME_FOLDER = "foldersActions::renameFolder";
export const RENAME_FOLDER_SUCCESS = "foldersActions::renameFolderSuccess";
export const RENAME_FOLDER_FAILED = "foldersActions::renameFolderFailed";
export const MOVE_FOLDER = "foldersActions::moveFolder";
export const MOVE_FOLDER_SUCCESS = "foldersActions::moveFolderSuccess";
export const MOVE_FOLDER_FAILED = "foldersActions::moveFolderFailed";
export const MARK_ALL_READ_FOLDER = "foldersActions::markAllReadFolder";
export const MARK_ALL_READ_FOLDER_SUCCESS =
  "foldersActions::markAllReadFolderSuccess";
export const MARK_ALL_READ_FOLDER_FAILED =
  "foldersActions::markAllReadFolderFailed";
export const CLEAR_FOLDER = "foldersActions::clearFolder";
export const CLEAR_FOLDER_SUCCESS = "foldersActions::clearFolderSuccess";
export const CLEAR_FOLDER_FAILED = "foldersActions::clearFolderFailed";
export const DELETE_FOLDER = "foldersActions::deleteFolder";
export const DELETE_FOLDER_SUCCESS = "foldersActions::deleteFolderSuccess";
export const DELETE_FOLDER_FAILED = "foldersActions::deleteFolderFailed";
export const CHANGE_FOLDER_COLOR = "foldersActions::changeFolderColor";
export const CHANGE_FOLDER_COLOR_SUCCESS =
  "foldersActions::changeFolderColorSuccess";
export const CHANGE_FOLDER_COLOR_FAILED =
  "foldersActions::changeFolderColorFailed";
export const SET_FAILED = "foldersActions::setFailed";
export const RESET_FAILED = "foldersActions::resetFailed";

export const openFolderAdd = (parentFolder = null) => {
  return {
    type: OPEN_FOLDER_ADD,
    payload: {
      parentFolder
    }
  };
};

export const closeFolderAdd = () => {
  return {
    type: CLOSE_FOLDER_ADD
  };
};

export const openFolderRename = folder => {
  return {
    type: OPEN_FOLDER_RENAME,
    payload: {
      folder
    }
  };
};

export const lifeTimeValueError = err => {
  return {
    type: FOLDER_LIFETIME_FAIL,
    payload: {
      errorMessage: err.errorMessage
    }
  };
};
export const openFolderMarkAllRead = folder => {
  return {
    type: OPEN_FOLDER_MARK_ALL_READ,
    payload: {
      folder
    }
  };
};

export const closeFolderMarkAllRead = () => {
  return {
    type: CLOSE_FOLDER_MARK_ALL_READ
  };
};

export const closeFolderRename = () => {
  return {
    type: CLOSE_FOLDER_RENAME
  };
};

export const openFolderMove = folder => {
  return {
    type: OPEN_FOLDER_MOVE,
    payload: {
      folder
    }
  };
};

export const closeFolderMove = () => {
  return {
    type: CLOSE_FOLDER_MOVE
  };
};

export const openFolderClear = folder => {
  return {
    type: OPEN_FOLDER_CLEAR,
    payload: {
      folder
    }
  };
};

export const closeFolderClear = () => {
  return {
    type: CLOSE_FOLDER_CLEAR
  };
};

export const openFolderDelete = folder => {
  return {
    type: OPEN_FOLDER_DELETE,
    payload: {
      folder
    }
  };
};

export const closeFolderDelete = () => {
  return {
    type: CLOSE_FOLDER_DELETE
  };
};

export const addFolderItemsLifeTime = data => dispatch => {
  dispatch({
    type: ADD_LIFE_TIME
  });
  const { folder_id, ...obj } = data;
  return axiosV2
    .put(`/folders/${folder_id}`, obj)
    .then(response => {
      dispatch(
        obj.retention.keep === 0
          ? uiActions.addSnackbar({
              message: i18next.t("folders:properties.success_message")
            })
          : uiActions.addSnackbar({
              message: i18next.t("folders:properties.delete_message")
            })
      );
      dispatch({
        type: CLOSE_FOLDER_PROPERTIES
      });
      dispatch(
        folderActions.updateRetention(folder_id, response.data.retention)
      );
    })
    .catch(err => {
      dispatch({
        type: ADD_LIFE_TIME_ERROR,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const addFolder = data => dispatch => {
  dispatch({
    type: ADD_FOLDER
  });

  const parentFolderId = data.parent_id;
  const view = data.view || "message";

  return axiosV2
    .post("folders", data)
    .then(response => {
      dispatch({
        type: ADD_FOLDER_SUCCESS,
        payload: {
          folder: response.data,
          parentFolderId
        }
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("folders:add.success_message")
        })
      );
      return dispatch(folderActions.fetchFolders(true, view));
    })
    .catch(err => {
      dispatch({
        type: ADD_FOLDER_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const renameFolder = data => (dispatch, getState) => {
  dispatch({
    type: RENAME_FOLDER
  });

  const { folder_id, name, view = "message" } = data;
  return axiosV2
    .put(`/folders/${folder_id}`, { name })
    .then(() => {
      dispatch({
        type: RENAME_FOLDER_SUCCESS
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("folders:edit.success_message")
        })
      );
      return dispatch(folderActions.fetchFolders(true, view)).then(() => {
        const updatedFolder = getState().entities.folders.byId[folder_id];
        dispatch(
          folderActions.updateName(
            updatedFolder.id,
            updatedFolder.name,
            updatedFolder.absfolderpath
          )
        );
        return updatedFolder;
      });
    })
    .catch(err => {
      dispatch({
        type: RENAME_FOLDER_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const moveFolder = data => (dispatch, getState) => {
  dispatch({
    type: MOVE_FOLDER
  });

  const {
    view = "message",
    navigate,
    location,
    folder_id,
    prev_parent_id,
    parent_id,
    optimistic = false
  } = data;

  const basePath = view === "message" ? "/mailboxes" : `/${view}s`;
  const foldersOf = state => state?.entities?.folders;
  const pathBeforeMove = getFolderAbsPath(foldersOf(getState()), folder_id);
  const urlBeforeMove = location
    ? `${location.pathname}${location.search || ""}`
    : null;

  // the url of the folder you are standing in is built from its place in the
  // tree, so it has to follow the folder when it moves
  const syncUrl = fromPath => {
    if (!navigate || !location) {
      return null;
    }

    const url = buildSyncedFolderUrl({
      pathname: location.pathname,
      search: location.search,
      basePath,
      oldAbsPath: fromPath,
      newAbsPath: getFolderAbsPath(foldersOf(getState()), folder_id)
    });

    if (url) {
      navigate(url, { replace: true });
    }

    return url;
  };

  // the router commits url changes inside a transition. the tree update has to
  // join that same transition, otherwise react paints the moved tree under the
  // old url for a frame, the folder cannot be found there and a 404 flashes
  const moveItem = (from, to, sync) => {
    let url = null;

    startTransition(() => {
      dispatch(folderActions.moveItem(folder_id, from, to));
      url = sync();
    });

    return url;
  };

  let syncedUrl = null;

  if (optimistic) {
    syncedUrl = moveItem(prev_parent_id, parent_id, () =>
      syncUrl(pathBeforeMove)
    );
  }

  return axiosV2
    .put(`/folders/${folder_id}`, { parent_id })
    .then(() => {
      dispatch({
        type: MOVE_FOLDER_SUCCESS
      });
      if (!optimistic) {
        moveItem(prev_parent_id, parent_id, () => syncUrl(pathBeforeMove));
      }
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("folders:move.success_message")
        })
      );
    })
    .catch(err => {
      if (optimistic) {
        moveItem(parent_id, prev_parent_id, () => {
          if (syncedUrl && urlBeforeMove) {
            navigate(urlBeforeMove, { replace: true });
          }
        });
      }
      dispatch({
        type: MOVE_FOLDER_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
      dispatch(
        uiActions.addSnackbar({
          message: err.errorMessage || i18next.t("folders:move.error_message"),
          status: "error"
        })
      );
    });
};

export const markAllReadFolder = (activeFolderId, folder) => dispatch => {
  dispatch({
    type: MARK_ALL_READ_FOLDER
  });

  return axiosV2
    .put(`/folders/${folder.id}`, { read: "all" })
    .then(() => {
      dispatch({
        type: MARK_ALL_READ_FOLDER_SUCCESS,
        payload: {
          folderName: folder.name
        }
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("folders:mark_all_read.success_message")
        })
      );
      dispatch(folderActions.fetchSilentFolder({ id: folder.id }));
      const modifiedFolder = activeFolderId.split("/");
      const activeFolder = modifiedFolder?.[0];
      if (activeFolder?.toLowerCase() === folder.name?.toLowerCase()) {
        dispatch(
          messageActions.fetchMessages({
            folder: activeFolder
          })
        );
      }
    })
    .catch(err => {
      dispatch({
        type: MARK_ALL_READ_FOLDER_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const clearFolder =
  (activeFolderId, folder, view, navigate) => dispatch => {
    dispatch({
      type: CLEAR_FOLDER
    });

    let recursive = "false";
    if (folder.name?.toLowerCase() === "trash") {
      recursive = "true";
    }

    if (
      activeFolderId?.toLowerCase()?.includes("trash") &&
      folder.name?.toLowerCase() === "trash"
    ) {
      if (view === "message") {
        navigate("/mailboxes/trash");
      } else {
        navigate(`/${view}s/trash`);
      }
    }

    return axiosV2
      .delete(`/folders/${folder.id}?delete_type=empty&recursive=${recursive}`)
      .then(() => {
        dispatch({
          type: CLEAR_FOLDER_SUCCESS,
          payload: {
            folderName: folder.name
          }
        });
        dispatch(
          uiActions.addSnackbar({
            message: i18next.t("folders:clear.success_message")
          })
        );
        dispatch(folderActions.fetchSilentFolder({ id: folder.id }));
        const modifiedFolder = activeFolderId?.split("/");
        const activeFolder = modifiedFolder?.[0];

        if (
          activeFolder?.toLowerCase() === folder.name?.toLowerCase() &&
          view === "message"
        ) {
          dispatch(
            messageActions.fetchMessages({
              folder: activeFolder
            })
          );
        }
      })
      .catch(err => {
        dispatch({
          type: CLEAR_FOLDER_FAILED,
          payload: {
            errorMessage: err.errorMessage
          }
        });
      });
  };

export const deleteFolder =
  (activeFolderId = "", folder, view, navigate) =>
  dispatch => {
    dispatch({
      type: DELETE_FOLDER
    });
    let q = "trash";

    if (folder?.status?.toLowerCase() === "intrash") {
      q = "delete";
    }

    if (activeFolderId?.toLowerCase()?.includes("trash") && q === "delete") {
      if (view === "message") {
        navigate("/mailboxes/trash");
      } else {
        navigate(`/${view}s/trash`);
      }
    }

    if (activeFolderId?.toLowerCase()?.includes(folder.name?.toLowerCase())) {
      if (view === "message") {
        navigate("/mailboxes/inbox");
      } else {
        navigate(`/${view}s/inbox`);
      }
    }

    return axiosV2
      .delete(`/folders/${folder.id}?delete_type=${q}`)
      .then(() => {
        dispatch({
          type: DELETE_FOLDER_SUCCESS
        });
        dispatch(folderActions.deleteItem(folder.id));
        dispatch(
          uiActions.addSnackbar({
            message: i18next.t("folders:delete.success_message")
          })
        );
      })
      .catch(err => {
        dispatch({
          type: DELETE_FOLDER_FAILED,
          payload: {
            errorMessage: err.errorMessage
          }
        });
      });
  };

export const changeFolderColor = data => dispatch => {
  const { folder_id, ...obj } = data;
  return axiosV2
    .put(`/folders/${folder_id}`, obj)
    .then(() => {
      dispatch(
        folderActions.changeColor({
          folderId: data.folder_id,
          color: data.color
        })
      );
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("folders:color.success_message")
        })
      );
    })
    .catch(err => {
      dispatch(
        uiActions.addSnackbar({
          message: err.errorMessage
        })
      );
    });
};

export const setFailed = errorMessage => ({
  type: SET_FAILED,
  payload: {
    errorMessage
  }
});

export const resetFailed = () => ({
  type: RESET_FAILED
});

export const openFolderPreporties = folder => {
  return {
    type: OPEN_FOLDER_PROPERTIES,
    payload: {
      folder
    }
  };
};

export const closeFolderProperties = () => {
  return {
    type: CLOSE_FOLDER_PROPERTIES
  };
};

export const openFolderShare = folder => {
  return {
    type: OPEN_FOLDER_SHARE,
    payload: {
      folder
    }
  };
};

export const closeFolderShare = () => {
  return {
    type: CLOSE_FOLDER_SHARE
  };
};
